<div class="load-indicator-container" [ngClass]="{'load-indicator-hidden': !isShown()}">
   <span class="load-indicator-img"></span>
   <span class="load-indicator-text">Loading...</span>
</div>
